import type { ReactNode } from 'react'
import { Badge } from './Badge'
import { cn } from '../../lib/utils'

interface TrustBadgeProps {
  label: string
  detail?: string
  icon?: ReactNode
  tone?: 'success' | 'info' | 'gold' | 'neutral'
  className?: string
}

export function TrustBadge({ label, detail, icon, tone = 'success', className }: TrustBadgeProps) {
  return (
    <div className={cn('trust-badge', className)}>
      {icon && <span className="trust-badge-icon">{icon}</span>}
      <div className="trust-badge-copy">
        <Badge tone={tone}>{label}</Badge>
        {detail && <span className="caption trust-badge-detail">{detail}</span>}
      </div>
    </div>
  )
}
